module.exports = __webpack_public_path__ + "img/logo-elitesport.f1d7d227.png";